import React from 'react';

import Spinner from 'react-spinkit';

class Loader extends React.Component {
  constructor (props) {
    super(props);

    this.state = {};
  }

  render () {
    if (this.props.loading) {
      return (
        <div className='loader-container'>
          <div className='loader'>
            <Spinner type='three-bounce' />
          </div>
        </div>
      )
    }
    else {
      return false;
    }
  }
}

Loader.defaultProps = {
  loading: false
}

export default Loader;



/** WEBPACK FOOTER **
 ** ./modules/shared/loader.js
 **/